export default __webpack_public_path__ + "static/media/help2.eeb4ca79.png";